import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  signup_count: number;
}

const SignupsCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "Sign-ups",
  accessorFn: (row) => row.signup_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default SignupsCol;
